/* eslint-disable no-undef */
import i18n from 'i18next';
import Backend from './backend';
import { setMomentLocale } from './momentLocale';

let instance;

function init(commonStore) {
    i18n.use({
        type: 'postProcessor',
        name: 'companyOverrides',
        process: function (value, key) {
            try {
                const brandingStore = window.__stores.brandingStore || {};
                if (!brandingStore || !brandingStore.brandingLoaded) {
                    return value;
                }

                const assessmentStore = window.__stores.assessmentStore || {};
                const questionStore = window.__stores.questionStore || {};

                const lng = i18n.language;
                const prefix = `ui.translation.${lng}.`;

                const fullKey = `${prefix}${key}`;

                if (
                    questionStore &&
                    questionStore.question &&
                    questionStore.question &&
                    questionStore.question.translations
                ) {
                    if (questionStore.question.translations[fullKey]) {
                        return questionStore.question.translations[fullKey];
                    }
                }

                if (
                    assessmentStore &&
                    assessmentStore.assessment &&
                    assessmentStore.assessment.definition &&
                    assessmentStore.assessment.definition.translations
                ) {
                    if (
                        assessmentStore.assessment.definition.translations[
                            fullKey
                        ]
                    ) {
                        return assessmentStore.assessment.definition
                            .translations[fullKey];
                    }
                }

                const override = brandingStore.branding[fullKey];
                if (override) {
                    return override;
                }

                return value;
            } catch (error) {
                console.error('Error in companyOverrides processor:', error);
                return value;
            }
        },
    });

    instance = i18n.use(Backend).init({
        react: {
            useSuspense: false,
        },
        lng: window.localStorage.getItem('language') || 'en',
        fallbackLng: 'en',
        // load: "languageOnly",
        ns: ['common', 'assessment'],
        defaultNS: 'common',
        keySeparator: false,
        backend: {
            loadPath: `/static/locales/{{lng}}/{{ns}}.json`,
            commonStore,
        },
        debug: false,
        postProcess: ['companyOverrides'],
    });
    let lng = window.localStorage.getItem('language') || 'en';
    setMomentLocale(lng);
    return instance;
}

i18n.on('languageChanged', function (lng) {
    setMomentLocale(lng);
});

export default { init };
